import { useEffect, useState } from "react"
import { findPostSessionPending, type PostSessionPending } from "@/lib/supabase"

/**
 * Ce qui attend une réponse au questionnaire post-séance — indicateur du bouton
 * « Post-séance » du Monitoring. Même recherche que le questionnaire ouvert par ce
 * bouton : l'indicateur annonce exactement ce que le bouton ouvrira.
 *
 * Relu au retour au premier plan, et à l'heure de fin d'une activité verrouillée :
 * « disponible à 15h10 » devient la pastille à 15h10 sans quitter la page.
 */
export function usePostSessionPending(): PostSessionPending | null {
  const [pending, setPending] = useState<PostSessionPending | null>(null)
  const [refreshKey, setRefreshKey] = useState(0)

  useEffect(() => {
    let cancelled = false
    findPostSessionPending()
      .then((p) => { if (!cancelled) setPending(p) })
      .catch((err) => console.error("[usePostSessionPending]", err))
    return () => { cancelled = true }
  }, [refreshKey])

  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === "visible") setRefreshKey((k) => k + 1)
    }
    document.addEventListener("visibilitychange", onVisible)
    return () => document.removeEventListener("visibilitychange", onVisible)
  }, [])

  useEffect(() => {
    if (pending?.kind !== "activity" || !pending.locked) return
    const delay = pending.endAt.getTime() - Date.now() + 1000
    // setTimeout plafonne à ~24,8 jours ; une fin prévue est toujours aujourd'hui.
    const id = window.setTimeout(() => setRefreshKey((k) => k + 1), Math.max(delay, 0))
    return () => window.clearTimeout(id)
  }, [pending])

  return pending
}
